import { render, staticRenderFns } from "./verifyMail.vue?vue&type=template&id=854d1700"
import script from "./verifyMail.vue?vue&type=script&lang=js"
export * from "./verifyMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports